/**

* =============================================================
* AADHAV ACADEMY – ADMIN BRANCHES API
* Role: Admin
* Scope: Tenant-based branch management
* Standard: Enterprise / MNC Level
* =============================================================
  */

import { apiCall } from "../core/apiCall";

/* =============================================================
BASE ENDPOINT
============================================================= */
const ADMIN_BRANCHES_ENDPOINT = "/admin/branches/index.php";

/* =============================================================
GET – Fetch Branches
Supports: pagination, search
============================================================= */
export const getAdminBranches = async (
{ page = 1, limit = 10, search = "" } = {},
options = {}
) => {
try {
const res = await apiCall(
"GET",
ADMIN_BRANCHES_ENDPOINT,
null,
"Admin – Fetch Branches",
{
params: { page, limit, search },
...options,
}
);


if (!res || res.status !== true) {
  return {
    success: false,
    message: res?.message || "Failed to fetch branches",
    data: [],
    meta: {},
  };
}

return {
  success: true,
  data: res.data || [],
  meta: res.meta || {
    total: 0,
    page: 1,
    limit,
    total_pages: 0,
  },
};


} catch (error) {
console.error("Admin Fetch Branches Error:", error);


return {
  success: false,
  message: error.message || "Unexpected error occurred",
  data: [],
  meta: {},
};


}
};

/* =============================================================
GET – Fetch Single Branch
URL: /admin/branches/index.php?id=ID
============================================================= */
export const getAdminBranchById = async (
id,
options = {}
) => {
try {
if (!id) {
return {
success: false,
message: "Invalid branch ID",
};
}


const res = await apiCall(
  "GET",
  `${ADMIN_BRANCHES_ENDPOINT}?id=${id}`,
  null,
  "Admin – Fetch Branch By ID",
  options
);

if (!res || res.status !== true) {
  return {
    success: false,
    message: res?.message || "Failed to fetch branch",
  };
}

return {
  success: true,
  data: res.data,
};


} catch (error) {


console.error(
  "Admin Fetch Branch By ID Error:",
  error
);

return {
  success: false,
  message:
    error.message ||
    "Unexpected error occurred",
};


}
};

/* =============================================================
POST – Create Branch
============================================================= */
export const createAdminBranch = async (
payload,
options = {}
) => {
try {
const res = await apiCall(
"POST",
ADMIN_BRANCHES_ENDPOINT,
payload,
"Admin – Create Branch",
options
);


if (!res || res.status !== true) {
  return {
    success: false,
    message: res?.message || "Failed to create branch",
  };
}

return {
  success: true,
  data: res.data || null,
  message:
    res.message ||
    "Branch created successfully",
};


} catch (error) {


console.error(
  "Admin Create Branch Error:",
  error
);

return {
  success: false,
  message:
    error.message ||
    "Unexpected error occurred",
};


}
};

/* =============================================================
PUT – Update Branch
URL: /admin/branches/index.php?id=ID
============================================================= */
export const updateAdminBranch = async (
id,
payload,
options = {}
) => {
try {


if (!id) {
  return {
    success: false,
    message: "Invalid branch ID",
  };
}

const res = await apiCall(
  "PUT",
  `${ADMIN_BRANCHES_ENDPOINT}?id=${id}`,
  payload,
  "Admin – Update Branch",
  options
);

if (!res || res.status !== true) {
  return {
    success: false,
    message:
      res?.message ||
      "Failed to update branch",
  };
}

return {
  success: true,
  data: res.data || null,
  message:
    res.message ||
    "Branch updated successfully",
};


} catch (error) {


console.error(
  "Admin Update Branch Error:",
  error
);

return {
  success: false,
  message:
    error?.message ||
    "Unexpected error occurred",
};


}
};

/* =============================================================
DELETE – Remove Branch
URL: /admin/branches/index.php?id=ID
============================================================= */
export const deleteAdminBranch = async (
id,
options = {}
) => {
try {


if (!id) {
  return {
    success: false,
    message: "Invalid branch ID",
  };
}

const res = await apiCall(
  "DELETE",
  `${ADMIN_BRANCHES_ENDPOINT}?id=${id}`,
  null,
  "Admin – Delete Branch",
  options
);

if (!res || res.status !== true) {
  return {
    success: false,
    message:
      res?.message ||
      "Failed to delete branch",
  };
}

return {
  success: true,
  message:
    res.message ||
    "Branch deleted successfully",
};


} catch (error) {


console.error(
  "Admin Delete Branch Error:",
  error
);

return {
  success: false,
  message:
    error.message ||
    "Unexpected error occurred",
};


}
};
